// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

/**
 * `_bestScore` — the running cycle's current best score, the max of the
 * snapshot's top-K `best_agent_scores` (the *current* leaderboard
 * high-water mark, not a per-iter series). Already-fetched data in, a
 * derived value out — no fetch (INV-5).
 */

import { isFiniteNumber } from "@/lib/number-guards"

export const selectCurrentBestScore = (
  bestAgentScores: ReadonlyArray<number> | null | undefined,
): number | null => {
  if (bestAgentScores == null || bestAgentScores.length === 0) return null
  const best = Math.max(...bestAgentScores)
  return isFiniteNumber(best) ? best : null
}
